import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  instructors: [],
  loading: false,
  error: null
};

const instructorsSlice = createSlice({
  name: 'instructors',
  initialState,
  reducers: {
    setInstructors: (state, action) => {
      state.instructors = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setInstructors, setLoading, setError } = instructorsSlice.actions;
export default instructorsSlice.reducer;
